import { render, staticRenderFns } from "./tabs-header.vue?vue&type=template&id=aba50f48&scoped=true&"
import script from "./tabs-header.vue?vue&type=script&lang=js&"
export * from "./tabs-header.vue?vue&type=script&lang=js&"
import style0 from "./tabs-header.vue?vue&type=style&index=0&id=aba50f48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba50f48",
  null
  
)

export default component.exports